import { Pipe, PipeTransform } from '@angular/core'
import { DecimalPipe } from '@angular/common'
import { environment } from 'environments/environment'

@Pipe({
  standalone: false,
  name: 'hideZeroValues',
})
export class HideZeroValuesPipe implements PipeTransform {
  constructor(private decimal: DecimalPipe) {}

  transform(value: any, args?: any): any {
    const num = Number(value)
    const hideZeroValues =
      (environment as any).hideZeroValues === undefined ||
      (environment as any).hideZeroValues
    const label = hideZeroValues ? 'NA' : 0
    const isValid = !isNaN(num) && Number.isFinite(num) && num !== 0
    return isValid ? this.decimal.transform(value, args) : label
  }
}
